import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(({ isActive, ...rest }) => <Link {...rest} />)`
  text-decoration: none;
  color: ${props => (props.isActive ? 'white;' : 'inherit;')};
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 50px 10px 95px;
  background-color: ${props => (props.isActive ? '#2cc4f4' : '#00013e')};
  ${props =>
    !props.isActive &&
    `
  &:hover, &:focus {
    background-color: rgba(255,255,255, 0.2);
    color: white;
  }
  `};
`;

const StyledListItem = styled.li`
  width: 100%;
`;

class ReportTabItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <StyledListItem>
        <StyledLink
          tabIndex={this.props.tabIndex}
          isActive={
            this.props.currentReportId === this.props.selectedReportId &&
            this.props.currentReportPageId ===
              this.props.selectedReportPageId &&
            this.props.reportTab.id === this.props.selectedReportTabId
          }
          to={`/reports/${this.props.currentReportId}/v/${
            this.props.reportVersionString
          }/pages/${this.props.currentReportPageId}/tabs/${
            this.props.reportTab.id
          }`}
        >
          {this.props.customReportTabName || this.props.reportTab.name}
        </StyledLink>
      </StyledListItem>
    );
  }
}

export default ReportTabItem;
